export default __webpack_public_path__ + "static/media/drop.acc4401a.gif";